export const jobListingsApi = (http) => {
  return {
    fetchListings: async () => {
      const res = await http.get('/api/joblistings/');
      return res;
    },
  };
};
